import React from "react";
import { InlineSpinner } from "./InlineSpinner";
import AuthBrand from "./AuthBrand";
import "../styles/authSurface.css";

/**
 * Full-viewport loading shell for auth and bootstrap states.
 *
 * @example
 * if (authLoading) return <AppLoadingShell text="Loading…" />;
 */
const AppLoadingShell = ({ text = "Loading…" }) => (
  <div className="app-loading-shell auth-surface">
    <div className="app-loading-shell__content">
      <AuthBrand className="task-mantis-auth-brand--compact app-loading-shell__brand" />
      <InlineSpinner text={text} />
    </div>
  </div>
);

export default AppLoadingShell;
